import { render } from "./OpenSourcePackage.vue?vue&type=template&id=49671248&ts=true"
import script from "./OpenSourcePackage.vue?vue&type=script&lang=ts"
export * from "./OpenSourcePackage.vue?vue&type=script&lang=ts"

import "./OpenSourcePackage.vue?vue&type=style&index=0&id=49671248&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__